import React from 'react';
import MobileHeader from './MobileHeader';
import NavBar from './NavBar';

const Header = () => {
  return (
    <header>
      <div className="mobile-only">
        <MobileHeader />
      </div>
      <div className="desktop-only">
        <NavBar />
      </div>
      <style>
        {`
          /* Por defecto, se muestra solo el nav de escritorio */
          .mobile-only {
            display: none;
          }
          .desktop-only {
            display: block;
          }
          /* En pantallas de 768px o menos, se muestra el móvil y se oculta el escritorio */
          @media screen and (max-width: 768px) {
            .mobile-only {
              display: block;
            }
            .desktop-only {
              display: none;
            }
          }
        `}
      </style>
    </header>
  );
};

export default Header;
